import axios from 'axios';

const messageService = {
  /**
   * 提交留言
   * @param {Object} messageData - 留言数据
   * @param {string} messageData.name - 姓名
   * @param {string} messageData.contact - 联系方式
   * @param {string} messageData.content - 留言内容
   * @returns {Promise} 返回操作结果
   */
  submitMessage(messageData) {
    return axios.post('/api/messages', messageData, {
      timeout: 5000
    });
  },

  /**
   * 获取留言列表（仅供后台使用）
   * @param {Object} params - 查询参数
   * @param {number} params.page - 当前页码
   * @param {number} params.limit - 每页数量
   * @returns {Promise} 返回留言列表数据
   */
  getMessageList(params = {}) {
    return axios.get('/api/admin/messages', {
      params,
      timeout: 5000
    });
  },

  /**
   * 删除留言（仅供后台使用）
   * @param {number} id - 留言ID
   * @returns {Promise} 返回操作结果
   */
  deleteMessage(id) {
    return axios.delete(`/api/admin/messages/${id}`, {
      timeout: 5000
    });
  }
};

export default messageService; 